<template>
  <div
    class="window-item window-item_greed"
    :class="[
      isCalled ? 'animation_is-called' : '',
      $store.infoscreenData.ticketCallAnimation,
    ]"
    :style="{ backgroundColor: $store.infoscreenData.infoboardBackgroundColor }"
  >
    <div class="window-info">
      <p ref="windowNumber" class="window-number" :style="stylesWindowNumber">
        {{ WINDOW_TYPE_TRANSLATIONS[ticket.window.type] | translate }}
        {{ ticket.window.number }}
      </p>
      <p class="window-id" :style="stylesTicketNumber">
        {{ ticket.prefix }}{{ ticket.number }}
      </p>
    </div>
    <TicketIcon
      v-if="$store.deviceStartData.are_arrows_enabled"
      class="icon"
      :icon="ticket.window.arrow"
      :color="$store.infoscreenData.infoboardWindowColor"
    />
  </div>
</template>

<script>
import TicketMixin from '../../mixins/TicketMixin';

function getSearchParam(param) {
  const params = new URL(document.location).searchParams;
  return params.get(param);
}

export default {
  name: 'TicketGreed',
  mixins: [TicketMixin],
  data() {
    return {
      defaultWindowNumberFontSize: 4.58333333,
      windowNumberFontSize: 4.58333333,
    };
  },
  computed: {
    fontFamily() {
      return `${this.$store.infoscreenData.fontBoldFamily}, ${this.$store.fontFamilyDefault}, sans-serif`;
    },
    stylesTicketNumber() {
      const styles = {
        color: this.$store.infoscreenData.infoboardTicketNumberColor,
        fontFamily: this.fontFamily,
      };

      const fontSize = getSearchParam('fs_ticket');
      if (fontSize) {
        return { ...styles, fontSize: `${fontSize}px` };
      }
      return styles;
    },
    stylesWindowNumber() {
      const styles = {
        color: this.$store.infoscreenData.infoboardWindowColor,
        fontFamily: this.fontFamily,
      };

      const fontSize = getSearchParam('fs_window');
      return {
        ...styles,
        fontSize: fontSize ? `${fontSize}px` : `${this.windowNumberFontSize}vw`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.window-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  .window-info {
    max-width: calc(100% - 12.5vw);
    display: flex;
    flex-direction: column;
  }

  .window-number {
    white-space: nowrap;
    line-height: 9.25925926vh;
    font-weight: 600;
  }

  .window-id {
    font-size: 7.60416667vw;
    font-weight: 600;
  }
}

.icon {
  width: 11.875vw;
  height: 11.875vw;
  display: block;
}
</style>
